import React from "react"
import SponsorBandEditor from "components/Common/SponsorBand/BandEditor"
import { partnerLogoSrc } from "./partnerPayload"

// The system band as the public page will draw it, made editable in place. The editor itself is
// shared with the event sponsor band (components/Common/SponsorBand/BandEditor); what is bound here
// is the copy — a plate opens a contract and its markets, and the public pages lag a cache behind.

const BandEditor = props => (
  <SponsorBandEditor
    {...props}
    title="The band, as it will render"
    description="Drag a plate to reorder it, drop it in another tier to re-tier it. Click a plate to edit its contract and markets."
    footnote="Changes reach the public pages within 15 minutes."
    editLabel="edit contract and markets"
    addLabel={tierLabel => `Add a partner to ${tierLabel}`}
    logoSrc={partnerLogoSrc}
  />
)

export default BandEditor
